import { Rating } from '@mui/material';
import Flex from 'frontend/commons/Flex';
import IconButton from 'frontend/components/packages/components/IconButton';
import capitalizeWords from 'frontend/utils/capitalize-words';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';

const HotelInfoCard = ({
  hotel,
  totalNightText,
  provider_id,
  hotelInformation,
}) => {
  const { t } = useTranslation('layout');
  const [displayDescription, setDisplayDescription] = useState(false);

  const handleDisplayDescriptionToggle = (value) => {
    setDisplayDescription(value !== undefined ? !!value : (state) => !state);
  };
  return (
    <Flex className="package-details__dynamic-content__wrapper__hotel-list__records__card">
      <Flex
        vertical
        className="package-details__dynamic-content__wrapper__hotel-list__records__card__info"
      >
        <Flex className="package-details__dynamic-content__wrapper__hotel-list__records__card__info__wrapper">
          <Flex
            vertical
            className="package-details__dynamic-content__wrapper__hotel-list__records__card__info__title"
          >
            <h5>{capitalizeWords(hotel.hotel.name)}</h5>
            <Rating
              readOnly
              size="small"
              className="package-details__dynamic-content__wrapper__hotel-list__records__card__info__title__rating"
              value={hotel.hotel.category}
            />
          </Flex>
        </Flex>
        <Flex className="package-details__dynamic-content__wrapper__hotel-list__records__card__info__details">
          <strong className="package-details__dynamic-content__wrapper__hotel-list__records__card__info__details__first-line">
            <span>{totalNightText}</span>
            <span>{capitalizeWords(hotel.regime)}</span>
            <span>{capitalizeWords(hotel.roomType)}</span>
          </strong>
          {provider_id === 3 && displayDescription == false ? (
            <FaPlusCircle
              onClick={() => {
                handleDisplayDescriptionToggle();
              }}
              className={'package-simple-icon-button active'}
            />
          ) : provider_id === 3 && displayDescription == true ? (
            <FaMinusCircle
              onClick={() => {
                handleDisplayDescriptionToggle();
              }}
              className={'package-simple-icon-button'}
            />
          ) : null}
          {provider_id === 3 && (
            <>
              {!displayDescription ? (
                <FaPlusCircle
                  onClick={() => {
                    handleDisplayDescriptionToggle();
                  }}
                  className={'package-simple-icon-button active'}
                />
              ) : (
                <FaMinusCircle
                  onClick={() => {
                    handleDisplayDescriptionToggle();
                  }}
                  className={'package-simple-icon-button'}
                />
              )}
            </>
          )}
        </Flex>
        {displayDescription && provider_id === 3 && (
          <Flex className="package-details__dynamic-content__wrapper__hotel-list__records__card__info__description__content">
            {hotelInformation?.[0]?.hotel?.description}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default HotelInfoCard;
